export enum PrivacyType {
  Private = "Private",
  Public = "Public",
}

export enum TrackerStatus {
  APPLIED = "Applied",
  APPLICATIONVIEWED = "Application Viewed",
  INTERVIEWSCHEDULED = "Interview Scheduled",
  CANDIDATEPLACED = "Candidate Placed",
  SHORTLIST = "Shortlist",
  DECLINE = "Decline",
  SUBMITOFFER = "Submit Offer",
  JOBCLOSE = "Job Close",
  SUBMIT_TO_HIRING_COMPANY = "Submit To Hiring Company",
  APPLICATION_VIEWED_BY_HIRING_COMPANY = "Application Viewed By Hiring Company",
  REQUEST_EXCLUSIVE_REPRESENTATION = "Request Exclusive Representation"
}

export enum HiringCompanyTrackerStatus {
  SHORTLIST = "Shortlist candidate",
  SEND_MEETING_INVITATION = "Send meeting invitation",
  DECLINE = "Reject candidate",
}
